import { render, staticRenderFns } from "./PhoneSection.vue?vue&type=template&id=1a9d75ae"
import script from "./PhoneSection.vue?vue&type=script&lang=js"
export * from "./PhoneSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports